import {
  ComponentPropsWithoutRef,
  ForwardedRef,
  forwardRef,
  ReactNode,
} from "react";

type OverlayContainerProps = ComponentPropsWithoutRef<"div"> & {
  children?: ReactNode;
};

const baseClasses =
  "absolute top-[20%] flex h-[75%] w-[85%] items-center justify-center p-[0.5vw]";

export const OverlayContainer = forwardRef(function OverlayContainer(
  { className = "", ...rest }: OverlayContainerProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const merged = ["overlay-3d-container", baseClasses, className]
    .filter(Boolean)
    .join(" ");
  return <div ref={ref} className={merged} {...rest} />;
});

export const FlatOverlayContainer = forwardRef(function FlatOverlayContainer(
  { className = "", ...rest }: OverlayContainerProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const merged = ["overlay-flat-container", baseClasses, className]
    .filter(Boolean)
    .join(" ");
  return <div ref={ref} className={merged} {...rest} />;
});
